export default {"src":"/_next/static/media/hivemapper-logo.47f9f5f1.svg","height":34,"width":212,"blurWidth":0,"blurHeight":0};